import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  components: { POIStep },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  created() {
    if (!this.editedItem.camping) {
      this.$set(this.editedItem, "camping", {
        tentPitches: undefined,
        caravanPitches: undefined
      });
    }
  },
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
